/* eslint-disable no-unused-vars */
import { axiosPublic, axiosPrivate, getSequencer, getLocale } from ".";
import store from "../store";

export const getFilteredEvents = () =>
  axiosPrivate.post(
    "loja/produto/listar",
    {
      loja: getSequencer(),
      lang: getLocale(),
      filtros: [
        {
          campo: "prod.ins_dthr",
          orientacao: "maior",
          tipo: "date",
          valor:
            store.getters.storeSequencial == "2" ? "2023-10-27" : "2024-02-28",
        },
      ],
      periodo_valido_vendas: false,
    },
    { cache: true }
  );

export const sendToken = () =>
  axiosPrivate.put(
    "loja/carteiradigital/token",
    {
      loja: getSequencer(),
    },
    { cache: false }
  );

export const getDigitalWalletValues = (idproduto, dthr_ini, dthr_fim) =>
  axiosPrivate.post(
    "loja/carteiradigital/valores",
    {
      loja: getSequencer(),
      idproduto: idproduto,
      dthr_ini: dthr_ini,
      dthr_fim: dthr_fim,
    },
    {
      cache: false,
    }
  );

export const getWithdrawals = (
  pesquisar,
  idproduto,
  data_inicial,
  data_final,
  exportType
) =>
  axiosPrivate.post(
    "loja/carteiradigital/listar",
    {
      loja: getSequencer(),
      pesquisar: pesquisar,
      idproduto: idproduto,
      data_inicial: data_inicial,
      data_final: data_final,
      exportation: exportType,
    },
    {
      cache: false,
      responseType: exportType ? "arraybuffer" : "json",
    }
  );

export const getWithdrawalById = idcarteira_digital =>
  axiosPrivate.post(
    `loja/carteiradigital/detalhe/${idcarteira_digital}`,
    {
      loja: getSequencer(),
    },
    {
      cache: false,
    }
  );

export const registerWithdrawal = (
  idproduto,
  valor_saque,
  dthr_saque,
  token,
  destinatario,
  cpf_cnpj,
  banco,
  agencia,
  tipo_conta,
  numero_conta,
  digito_conta,
  tipo
) =>
  axiosPrivate.post(
    "loja/carteiradigital/cadastro",
    {
      loja: getSequencer(),
      idproduto: idproduto,
      valor_saque: valor_saque,
      dthr_saque: dthr_saque,
      token: token,
      destinatario: destinatario,
      cpf_cnpj: cpf_cnpj,
      banco: banco,
      agencia: agencia,
      tipo_conta: tipo_conta,
      numero_conta: numero_conta,
      digito_conta: digito_conta,
      tipo: tipo,
    },
    {
      cache: false,
    }
  );

export const updateWithdrawal = (
  idcarteira_digital,
  valor_saque,
  dthr_aprovacao,
  status,
  idusuario_solicitacao,
  tipo_usuario_solicitacao,
  idusuario_aprovacao,
  destinatario,
  cpf,
  cnpj,
  banco,
  agencia,
  tipo_conta,
  numero_conta,
  digito_conta,
  idproduto,
  comprovante,
  tipo
) =>
  axiosPrivate.put(
    "loja/carteiradigital/alterar",
    {
      loja: getSequencer(),
      idcarteira_digital: idcarteira_digital,
      valor_saque: valor_saque,
      dthr_aprovacao: dthr_aprovacao,
      status: status,
      idusuario_solicitacao: idusuario_solicitacao,
      tipo_usuario_solicitacao: tipo_usuario_solicitacao,
      idusuario_aprovacao: idusuario_aprovacao,
      destinatario: destinatario,
      cpf: cpf,
      cnpj: cnpj,
      banco: banco,
      agencia: agencia,
      tipo_conta: tipo_conta,
      numero_conta: numero_conta,
      digito_conta: digito_conta,
      idproduto: idproduto,
      comprovante: comprovante,
      tipo: tipo,
    },
    { cache: false }
  );
